import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Public shell for the legal pages (/terms, /privacy). These are indexable,
 * unauthenticated documents — they must render with the public site framing
 * (back-to-home link + plain footer), never inside the app shell (sidebar,
 * command palette, app taglines).
 *
 * Dark design: the root carries `theme-sunset`, which is what flips
 * --landing-bg / --foreground to the navy + cream palette. Without it the
 * root token is the LIGHT off-white and the white/zinc prose below becomes
 * unreadable (audit C1, 2026-09-02).
 */
export function LegalLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="theme-sunset relative min-h-screen overflow-hidden bg-[hsl(var(--landing-bg))] text-foreground">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,hsl(var(--brand-gold)/0.06),transparent_28%)]" />

      <div className="relative mx-auto flex min-h-screen w-full max-w-4xl flex-col px-6 py-16 sm:px-10">
        <Link
          to="/"
          className="mb-12 inline-flex w-fit items-center gap-2 text-[10px] font-black uppercase tracking-[0.32em] text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Back to site
        </Link>

        {children}

        <footer className="mt-16 border-t border-white/10 pt-8 text-xs text-muted-foreground">
          <p>
            © {new Date().getFullYear()} Playce Academy · Kinetic Codex LLC ·{" "}
            <Link to="/terms" className="hover:text-foreground">Terms</Link> ·{" "}
            <Link to="/privacy" className="hover:text-foreground">Privacy</Link> ·{" "}
            <Link to="/support" className="hover:text-foreground">Support</Link>
          </p>
        </footer>
      </div>
    </div>
  );
}

export default LegalLayout;
